<script setup lang="ts">
import { keycloakReady, redirectToKeycloakLogin } from '@/plugins/vuekeycloak'

const theme = useTheme()
const storeU = useUtilisateurStore()
const errorText = ref('')
const { isAuthenticated } = useKeycloak()
const storeApp = useAppStore()

onMounted(async () => {
  await keycloakReady

  if (!isAuthenticated.value) {
    // Session expirée : relancer l'authentification plutôt que de bloquer sur une erreur.
    redirectToKeycloakLogin()
    return
  }

  if (storeU.estChargé()) {
    storeApp.showInitialLoader = false
    return
  } else {
    storeU.déconnexion()
  }

  try {
    await apiOmni.get('api/api/version')
  } catch (error) {
    errorText.value = "API Agri:" + error
    return
  }

  try {
    await apiProphet.get('api/version')
  } catch (error) {
    errorText.value = "API Prophet:" + error
    return
  }

  if (!storeU.utilisateur || storeU.utilisateur.id == undefined) {
    try {
      const response = await apiProphet.get('api/utilisateur')
      storeU.utilisateur = response.data
    } catch (error) {
      errorText.value = 'Impossible de récupérer les informations de l\'utilisateur\n' + error
      return
    }
  }

  if (!storeU.utilisateur || storeU.utilisateur.id == '') {
    errorText.value = "Vous n'êtes pas authentifié"
    return
  }

  if (!storeU.utilisateur.estAdministrateur &&
    (!storeU.utilisateur.accèsSite || storeU.utilisateur.accèsSite.length == 0)) {
    errorText.value = "Vous n'avez accès à aucun sites"
    return
  }

  if (storeU.sites.length == 0) {
    try {
      const response = await apiProphet.get('sites')
      storeU.sites = response.data
    } catch (error) {
      errorText.value = 'Impossible de récupérer les sites\n' + error
      return
    }
  }

  if (storeU.sites.length == 0) {
    errorText.value = "Aucun site trouvé"
    return
  }

  try {
    if (!storeU.siteSélectionné || !storeU.siteSélectionné.nom || storeU.siteSélectionné.nom == '') {
      await storeU.sélectionnerSite(storeU.sites[0].nom)
    }
  } catch (error) {
    errorText.value = "Site:" + error
    return
  }

  storeU.estChargéVersion = storeU.getVersion()
  storeU.estChargéDate = Date.now()
  storeApp.showInitialLoader = false
})
</script>

<template>
  <v-container fluid :class="theme.current.value.dark ? 'theme--dark' : ''">
    <div class="d-flex justify-center align-center" style="height: 100vh">
      <div class="d-flex flex-column align-items-center align-center justify-center">
        <div class="d-flex justify-center align-center">
          <v-progress-circular indeterminate :size="60" :width="6"/>
          <span class="ml-10"/>
          <v-card>
            <v-card-title class="text-center">Chargement...</v-card-title>
            <v-card-text class="text-center">Veuillez patienter</v-card-text>
          </v-card>
        </div>
        <v-alert v-if="errorText" type="error" class="mt-4">{{ errorText }}</v-alert>
      </div>
    </div>
  </v-container>
</template>
